import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { TrashIcon } from '@heroicons/react/24/outline'

import useServer from '../../../api/useServerMain'
import Input from '../../../components/forms/Input'
import TextArea from '../../../components/forms/TextArea'
import Toggle from '../../../components/forms/Toggle'
import AlertContainer from '../../../components/misc/AlertContainer'
import Button from '../../../components/misc/Button'
import GenericImageDrop from '../../../components/misc/Images/GenericImageDrop'
import Modal from '../../../components/modals/GenericModal'
import { SalesCategories } from '../../../interfaces/ServerInterfaces'
import { useAppSelector } from '../../../store/hooks'
import { useBusinessDataQuery } from '@/hooks/business/useBusinessDataQuery'
import { useBusinessPackagesQuery } from '@/hooks/business/useBusinessPackagesQuery'

interface FormSales {
  categoryData?: SalesCategories | null
  edit?: boolean
  closeModal: Function
  crud: { add: Function; upd: Function; del: Function; isFetching: boolean }
}

const FormSalesCategory = ({
  categoryData,
  edit,
  closeModal,
  crud,
}: FormSales) => {
  const { denyRoles } = useServer()
  const { control, handleSubmit } = useForm()
  const { add, del, upd, isFetching } = crud
  const { business } = useAppSelector((state) => state.init)
  const [deleteModal, setDeleteModal] = useState(false)
  const { businessData, isLoadingBusinessData, isErrorBusinessData } =
    useBusinessDataQuery({})
  const { businessPackages } = useBusinessPackagesQuery({
    params: { businessId: businessData?.id ?? 0 },
    options: {
      enabled:
        !!businessData?.id && !isLoadingBusinessData && !isErrorBusinessData,
    },
  })

  // const module_woocommerce =
  //   business?.configurationsKey.find(
  //     (item) => item.key === 'module_woocommerce'
  //   )?.value === 'true'
  const module_woocommerce = businessPackages?.find(
    (itm) => itm.code === 'M_ONLINE_SHOP'
  )?.isActive

  const onSubmit: SubmitHandler<Record<string, string | number | boolean>> = (
    data
  ) => {
    if (edit) {
      upd(categoryData?.id, data, closeModal)
    } else {
      add(data, closeModal)
    }
  }
  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-5 gap-3">
          <GenericImageDrop
            name="imageId"
            className="col-span-2 flex h-full w-full cursor-pointer justify-center rounded border border-gray-300 focus:outline-none"
            control={control}
            previewDefault={categoryData?.image?.src}
            previewHash={categoryData?.image?.blurHash}
          />
          <div className="col-span-3 rounded border border-gray-300 p-2">
            <div className="flex-col">
              <Input
                label="Nombre"
                name="name"
                control={control}
                placeholder="Nombre de la categoría"
                rules={{ required: 'Este campo es requerido' }}
                defaultValue={categoryData?.name}
              />
              {edit && (
                <>
                  <Input
                    label="Índice (Orden de aparición)"
                    name="index"
                    type="number"
                    control={control}
                    placeholder="Índice"
                    defaultValue={categoryData?.index}
                  />
                  <Toggle
                    name="isActive"
                    control={control}
                    defaultValue={categoryData?.isActive}
                    title="Activa"
                  />
                  {module_woocommerce && (
                    <Toggle
                      name="visibleOnline"
                      control={control}
                      defaultValue={categoryData?.visibleOnline}
                      title="Visible en tienda online"
                    />
                  )}
                </>
              )}
              <TextArea
                label="Descripción"
                name="description"
                placeholder="Breve descripción de la categoría"
                control={control}
                defaultValue={categoryData?.description}
              />
            </div>
          </div>
        </div>

        {denyRoles(['AUDITOR']) && (
          <div className="flex justify-end gap-2 p-3">
            {edit && (
              <Button
                name="Eliminar"
                color="red-500"
                icon={<TrashIcon className="h-5 text-red-500" />}
                action={() => setDeleteModal(true)}
                disabled={isFetching}
                outline
                textColor="red-500"
              />
            )}
            <Button
              name={edit ? 'Actualizar' : 'Insertar'}
              color="slate-600"
              type="submit"
              disabled={isFetching}
              loading={isFetching}
            />
          </div>
        )}
      </form>

      {deleteModal && (
        <Modal state={deleteModal} close={setDeleteModal}>
          <AlertContainer
            title={`Eliminar ${categoryData?.name}`}
            text="Seguro que desea eliminar esta categoría?"
            onAction={() => del(categoryData?.id, closeModal)}
            onCancel={setDeleteModal}
            loading={isFetching}
          />
        </Modal>
      )}
    </div>
  )
}

export default FormSalesCategory
